import React from 'react'
import homeland from '../images/logo.png'
import { MdOutlineLocationOn } from "react-icons/md";
import { IoIosCall } from "react-icons/io";
import { MdOutlineEmail } from "react-icons/md";
import { CiFacebook } from "react-icons/ci";
import { FaInstagram } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io5";

export default function Footer() {
    return (
        <>
            <div className='w-full bg-black text-white p-8 md:p-16 flex flex-col md:flex-row justify-between items-center'>
                {/* Logo */}
                <div className='img mb-8 md:mb-0'>
                    <img src={homeland} alt="Logo" className='w-40 h-auto' />
                </div>

                {/* Navigation - Address and Social Links */}
                <div className='navigations flex flex-col md:flex-row gap-12 md:gap-20 w-full md:w-[55%] justify-center'>

                    {/* Address Section */}
                    <div className='address flex flex-col gap-3 items-center md:items-start'>
                        <h3 className='font-["robecha-daniera"] capitalize text-xl md:text-2xl'>
                            Address
                        </h3>
                        <div className='mt-2'>
                            <p className='flex items-center text-lg md:text-xl gap-3'><MdOutlineLocationOn /> Sector 75, Mohali</p>
                            <p className='flex items-center text-lg md:text-xl gap-3'><IoIosCall /> +91 8950801205</p>
                            <p className='flex items-center text-lg md:text-xl gap-3'><MdOutlineEmail /> thechandigarhrealtor@gmail.com</p>
                        </div>
                    </div>

                    {/* Social Links Section */}
                    <div className='touch flex flex-col gap-3 items-center md:items-start'>
                        <h3 className='font-["robecha-daniera"] capitalize text-xl md:text-2xl'>
                            Get In Touch
                        </h3>
                        <div className='mt-2 flex gap-6'>
                            <a href='' className='text-2xl md:text-3xl'><CiFacebook /></a>
                            <a href='' className='text-2xl md:text-3xl'><FaInstagram /></a>
                            <a href='' className='text-2xl md:text-3xl'><IoLogoYoutube /></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
